import { LOAN_DETAILS_COLLECTION } from "./db";
export const getAllLoanDetails = () => {
  return LOAN_DETAILS_COLLECTION;
};

export const getSingleLoanDetails = (loadId) => {
  const loan =  LOAN_DETAILS_COLLECTION.filter(loan => loan.id === loadId)
    return loan && loan.length && loan[0]
};
